import React from 'react';
import Gallery from 'react-photo-gallery';
import Carousel, { Modal, ModalGateway } from 'react-images';
import Page from '../../components/page';

const photos = [
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA1.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA2.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA3.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA4.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA5.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA6.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA7.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA8.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA9.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA10.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA11.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA12.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA13.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA14.jpg', width: 4, height: 3 },
	{ src: 'https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/giveassured+images/GA17.jpg', width: 4, height: 3 },

];

class ImageGallery extends Page {
	constructor(props) {
		super(props);
		this.state = {
			currentImage: 0,
			modalIsOpen: false
		};
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	openModal(event, obj) {
		this.setState({
			currentImage: obj.index,
			modalIsOpen: true,

		});
	}

	closeModal() {
		this.setState({
			currentImage: 0,
			modalIsOpen: !this.state.modalIsOpen,
		});
	}

	render() {
		const modalIsOpen = this.state.modalIsOpen;

		return (
			<div>
				<Gallery photos={photos} onClick={this.openModal} />
				<ModalGateway>
					{modalIsOpen ? (
						<Modal onClose={this.closeModal}>
							<Carousel views={photos} currentIndex={this.state.currentImage} />
						</Modal>
					) : null}
				</ModalGateway>
			</div>
		);
	}
}

export default ImageGallery;
